"use client";

import { useEffect, useState } from "react";
import { TESTIMONIALS } from "@/constants/home.constants";

export function useTestimonialCarousel() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActive((prev) => (prev + 1) % TESTIMONIALS.length);
    }, 4500);
    return () => window.clearInterval(timer);
  }, []);

  const prev = () => setActive((p) => (p - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
  const next = () => setActive((p) => (p + 1) % TESTIMONIALS.length);

  return { active, setActive, prev, next };
}
